// src/router/index.ts

import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import { useUserStore } from "src/stores/userStore";

export default function () {
  const createHistory = createWebHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(import.meta.env.VITE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    const userStore = useUserStore();

    // ⛔ WAŻNE: Jeśli idziesz na /email-confirmed, przepuszczamy BEZ żadnej kontroli
    if (to.path === "/email-confirmed") {
      return next();
    }

    const publicPaths = [
      "/",
      "/login",
      "/register",
      "/pending-approval",
      "/email-confirmed", // <-- to zostaje w publicznych dla bezpieczeństwa
      "/complete-profile",
    ];
    const isPublic = publicPaths.includes(to.path);

    // Jeśli nie zalogowany i ścieżka niepubliczna → na login
    if (!userStore.isLoggedIn && !isPublic) {
      return next("/login");
    }

    // Jeśli zalogowany, ale niezatwierdzony i próbuje wejść gdzieś indziej niż /pending-approval
    if (
      userStore.isLoggedIn && !userStore.isApproved &&
      to.path !== "/pending-approval" && to.path !== "/complete-profile"
    ) {
      return next("/pending-approval");
    }

    // Dostęp do /admin tylko dla adminów
    if (to.path.startsWith("/admin") && !userStore.isAdmin) {
      return next("/dashboard");
    }

    // Jak ktoś zalogowany wchodzi na / → przekieruj na odpowiednią stronę
    if (to.path === "/" && userStore.isLoggedIn) {
      return next(userStore.isAdmin ? "/admin" : "/dashboard");
    }

    // Jeśli wszystko OK → przepuść dalej
    next();
  });

  return Router;
}
